import { some, map, defaultArg } from "../Bfs.Web.Kundenportal/fable_modules/fable-library-js.4.19.0/Option.js";
import { UrlHashPrefix, UrlCombine } from "./Helpers.fs.js";
import { Registry } from "./WebPart.fs.js";
import { singleton, ofArray, filter } from "../Bfs.Web.Kundenportal/fable_modules/fable-library-js.4.19.0/List.js";
import { printf, toText, substring, isNullOrWhiteSpace } from "../Bfs.Web.Kundenportal/fable_modules/fable-library-js.4.19.0/String.js";
import { Cmd_map, Cmd_none } from "../Bfs.Web.Kundenportal/fable_modules/Fable.Elmish.4.2.0/cmd.fs.js";
import { Msg, GlobalMsg, UserSession, Model } from "./Types.fs.js";
import { defaultOf } from "../Bfs.Web.Kundenportal/fable_modules/fable-library-js.4.19.0/Util.js";
import { add } from "../Bfs.Web.Kundenportal/fable_modules/fable-library-js.4.19.0/Map.js";
import { UnauthorizedException } from "./Http.fs.js";

export function pageHash(page) {
    return defaultArg(map(UrlCombine, Registry().TryBuildUrl(page)), "");
}

export function parseUrl(urlHash) {
    let hash;
    const segments = filter((arg) => !isNullOrWhiteSpace(arg), ofArray((hash = ((urlHash.indexOf("#") === 0) ? substring(urlHash, 1, urlHash.length - 1) : urlHash), hash.split("/"))));
    return Registry().TryParseUrl(segments);
}

export function handleUpdateUrl(nextPage, model) {
    const matchValue = Registry().TryInit(nextPage, model.User, model);
    if (matchValue == null) {
        return [model, Cmd_none()];
    }
    else {
        return [new Model(nextPage, matchValue[0], model.User, model.VideoOverlayVimeoId, model.MessageBox, model.IsBurgerMenuOpen, model.IsNotificationMenuOpen), matchValue[1]];
    }
}

export function init(page) {
    return handleUpdateUrl(page, new Model(defaultOf(), defaultOf(), undefined, undefined, undefined, false, false));
}

export function handleGlobalMsg(msg, model) {
    switch (msg.tag) {
        case 3:
            return [new Model(model.Page, model.PageModel, model.User, model.VideoOverlayVimeoId, msg.fields[0], model.IsBurgerMenuOpen, model.IsNotificationMenuOpen), Cmd_none()];
        case 4:
            return [new Model(model.Page, model.PageModel, model.User, model.VideoOverlayVimeoId, undefined, model.IsBurgerMenuOpen, model.IsNotificationMenuOpen), Cmd_none()];
        case 5:
            return [new Model(model.Page, model.PageModel, model.User, msg.fields[0], model.MessageBox, model.IsBurgerMenuOpen, model.IsNotificationMenuOpen), Cmd_none()];
        case 6:
            return [new Model(model.Page, model.PageModel, model.User, undefined, model.MessageBox, model.IsBurgerMenuOpen, model.IsNotificationMenuOpen), Cmd_none()];
        case 0:
        case 1:
        case 2:
            throw new Error("must be handeld bevor calling this update func");
        default: {
            const matchValue = model.User;
            if (matchValue != null) {
                const user = matchValue;
                return [new Model(model.Page, model.PageModel, new UserSession(user.Name, user.Email, user.Roles, user.IsNewCustomer, add(msg.fields[0], msg.fields[1], user.SessionData)), model.VideoOverlayVimeoId, model.MessageBox, model.IsBurgerMenuOpen, model.IsNotificationMenuOpen), Cmd_none()];
            }
            else {
                return [model, Cmd_none()];
            }
        }
    }
}

export function update(msg, model) {
    try {
        switch (msg.tag) {
            case 1: {
                const msg_2 = msg.fields[0];
                const globalmsg = Registry().TryGetGlobalMsg(msg_2);
                if (globalmsg == null) {
                    const next = Registry().TryUpdate(msg_2, model);
                    if (next == null) {
                        const msg_4 = toText(printf("Message konnte nicht dispatched werden: %O"))(msg_2);
                        console.error(some(msg_4));
                        return [model, Cmd_none()];
                    }
                    else {
                        return [next[0], next[1]];
                    }
                }
                else {
                    const m = globalmsg;
                    return [model, Cmd_map((Item) => (new Msg(0, [Item])), singleton((dispatch) => {
                        dispatch(m);
                    }))];
                }
            }
            case 3: {
                const page = msg.fields[0];
                const nextUrl = UrlHashPrefix(pageHash(page));
                history.pushState(undefined, "", nextUrl);
                const patternInput = handleUpdateUrl(page, model);
                const newModel = patternInput[0];
                return [new Model(newModel.Page, newModel.PageModel, newModel.User, newModel.VideoOverlayVimeoId, newModel.MessageBox, false, newModel.IsNotificationMenuOpen), patternInput[1]];
            }
            case 2: {
                const patternInput_1 = handleUpdateUrl(msg.fields[0], model);
                const newModel_1 = patternInput_1[0];
                return [new Model(newModel_1.Page, newModel_1.PageModel, newModel_1.User, newModel_1.VideoOverlayVimeoId, newModel_1.MessageBox, false, newModel_1.IsNotificationMenuOpen), patternInput_1[1]];
            }
            case 5:
                return [new Model(model.Page, model.PageModel, model.User, model.VideoOverlayVimeoId, model.MessageBox, !model.IsBurgerMenuOpen, model.IsNotificationMenuOpen), Cmd_none()];
            case 6:
                return [new Model(model.Page, model.PageModel, model.User, model.VideoOverlayVimeoId, model.MessageBox, model.IsBurgerMenuOpen, !model.IsNotificationMenuOpen), Cmd_none()];
            case 7:
            case 4:
                throw new Error("must be handeld bevor calling this update func");
            default:
                return handleGlobalMsg(msg.fields[0], model);
        }
    }
    catch (matchValue) {
        if (matchValue instanceof UnauthorizedException) {
            return [model, singleton((dispatch_1) => {
                dispatch_1(new Msg(0, [new GlobalMsg(1, [])]));
            })];
        }
        else {
            throw matchValue;
        }
    }
}

//# sourceMappingURL=MainDispatch.fs.js.map
